<sb-dialog-header>
  <h1 sb-dialog-title>{{ 'Create contract template' | translate }}</h1>
</sb-dialog-header>

<sb-dialog-content>
  <div class="mx-auto flex w-full max-w-3xl flex-col gap-xl">
    @if (progressState(); as state) {
      <detection-progress
        [state]="state"
        [ready]="store.scanFinished()"
        [fileName]="store.fileName()"
        (retry)="store.retry()"
        (uploadAgain)="store.reset()"
        (setUpManually)="setUpManually()"
      />
    } @else {
      <upload-step
        [isUploading]="store.isUploading()"
        [rejection]="store.uploadRejection()"
        (fileSelected)="store.upload($event)"
        (setUpManually)="setUpManually()"
      />
    }
  </div>
</sb-dialog-content>
